import {
  differenceInCalendarDays,
  isSameMonth,
  endOfDay,
  endOfMonth,
  startOfDay,
  startOfMonth,
  startOfToday,
  add,
  sub,
  fromUnixTime,
  isBefore,
  format,
} from 'date-fns';
import { hasValue } from 'swipeclock-frontend';

export function expirationForDate(exp) {
  const expiration = fromUnixTime(exp);
  const now = new Date();

  // For example, to check if the expiration date is in the past:
  const isExpired = isBefore(expiration, now);

  // If you need to format the date, you can use:
  const formattedExpiration = format(expiration, 'yyyy-MM-dd HH:mm:ss');

  // The difference between the expiration date and now, in milliseconds:
  const differenceBetweenNow = expiration.getTime() - now.getTime();

  return {
    differenceBetweenNow,
    expiration,
    isExpired,
    formattedExpiration,
  };
}

export function isSameDay(a, b) {
  if (hasValue(a) && hasValue(b)) {
    return differenceInCalendarDays(a, b) === 0;
  }
  return false;
}

export function isSameCalendarMonth(a, b) {
  return isSameMonth(a, b);
}

export function getDayRangeForDate(date) {
  const start = startOfDay(date);
  const end = endOfDay(date);
  return { start, end };
}

export function getMonthRangeForCalendar(date) {
  const start = sub(startOfMonth(date), { days: 12 });
  const end = add(endOfMonth(date), { days: 12 });
  return { start, end };
}

export function getMonthRangeForDate(date) {
  const start = startOfMonth(date);
  const end = endOfMonth(date);
  return { start, end };
}

export function getPreviousDay(date) {
  return sub(startOfDay(date), { days: 1 });
}

export function getNextDay(date) {
  return add(startOfDay(date), { days: 1 });
}

export function getPreviousMonth(date) {
  return sub(startOfDay(date), { months: 1 });
}

export function getNextMonth(date) {
  return add(startOfDay(date), { months: 1 });
}

export function getStartOfToday() {
  return startOfToday();
}

export function oneYearAgoFromToday() {
  return sub(startOfToday(), { years: 1 });
}

export function formatDate(date, formatString = 'yyyy-MM-dd') {
  return format(date, formatString);
}

export function isDateInPast(date) {
  return isBefore(date, startOfToday());
}

// Makes dates into format: 2021-01-26
export const formatDateForURL = (date = new Date()) =>
  format(date, 'yyyy-MM-dd');
